import { render, staticRenderFns } from "./EnsinoFund1.vue?vue&type=template&id=1452fa7b&scoped=true&"
import script from "./EnsinoFund1.vue?vue&type=script&lang=js&"
export * from "./EnsinoFund1.vue?vue&type=script&lang=js&"
import style0 from "./EnsinoFund1.vue?vue&type=style&index=0&id=1452fa7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452fa7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
